import { translateDesktopError } from '@/tauri/errors';

export { extractPluginError } from '@heidi/plugin-core';

/**
 * Command prefix for invoking Genie plugin commands via Tauri IPC.
 */
export const GENIE_COMMAND_PREFIX = 'plugin:genie|';

/**
 * Format a Tauri plugin error into a display string.
 *
 * If the error is a plugin error object `{ message, error_code }` and has
 * an i18n mapping, returns the translated message. Otherwise falls back
 * to the raw error message.
 */
export function formatError(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const obj = error as { message: string; error_code?: string };
    if (obj.error_code) {
      return translateDesktopError(obj.message, obj.error_code);
    }
    return obj.message;
  }
  return String(error);
}
